module.exports = __webpack_public_path__ + "static/WSC_Group_2015_Rental_Property_Tax_Checklist-94b2039b2d2af623bcd1af13f978007b.pdf";